<template>
  <div class="pub-wrap">
    <!-- header -->
    <section class="header">
      <div class="header-back" @click="goBack"></div>
      <div class="header-title">{{ title }}</div>

      <Button
        v-if="edit || editMode"
        class="bkcc-btn"
        @click.native="submit"
        >发布</Button
      >
      <Button v-else class="bkcc-btn" @click.native="toEdit"
        >编辑</Button
      >
    </section>

    <!-- content -->
    <section class="pub-content">
      <!-- left -->
      <Card class="card-wrap content-left">
        <Form :label-width="60">
          <FormItem
            v-for="item in formLeft"
            :key="item.name"
            :class="item.class"
            :prop="item.name"
          >
            <span class="form-label" slot="label">{{ item.label }}</span>

            <template v-if="item.type === 'input'">
              <Input v-model="item.value" v-if="edit || editMode" />
              <p v-else class="form-value">{{ item.value }}</p>
            </template>

            <!-- 人员选择 -->
            <select-person
              v-if="item.type === 'selectPerson'"
              :disabled="item.disabled"
              :src="item.src"
              :userName="item.userName"
              @click="onChoosePerson(item)"
            ></select-person>
          </FormItem>
        </Form>
      </Card>
      <!-- right -->
      <Card class="card-wrap content-right">
        <Form :label-width="80">
          <FormItem
            v-for="item in formRight"
            :key="item.name"
            :class="item.class"
          >
            <span class="form-label" slot="label">{{ item.label }}</span>
            <!-- 普通输入框 -->
            <template v-if="item.type === 'input'">
              <Input
                v-if="edit || editMode"
                v-model="item.value"
                :placeholder="item.placeholder"
                :type="item.inputType"
                :autosize="item.autosize"
                :maxlength="item.maxlength"
                :show-word-limit="item.showWordLimit"
              />
              <p v-else class="form-value">{{ item.value }}</p>
            </template>

             <template v-if="item.type === 'select'">
               <i-select v-model="item.value" style="width:200px" v-if="edit || editMode">
                  <i-option v-for="item in item.list" :value="item.value">{{ item.label }}</i-option>
               </i-select>
              <p v-else class="form-value">{{ statusList[item.value].label }}</p>
            </template>

            <!-- 带提示的输入 -->
            <template v-if="item.type === 'input-note'">
              <Input
                v-if="edit || editMode"
                v-model="item.value"
                :placeholder="item.placeholder"
              />
              <span v-if="edit || editMode" class="input-note">{{
                item.note
              }}</span>
              <p v-else class="form-value">{{ item.value }}</p>
            </template>

            <!-- 图片上传 isActive = readyonly  -->
            <upload-img
              v-if="item.type === 'uploadImg'"
              :imgArr="item.list"
              :imgNumber="item.imgNumber"
              :fixedNumber="item.fixedNumber"
              :imgHeight="140"
              :imgWidth="210"
              :isActive="!(edit || editMode)"
              @saveImg="onUploadImg(item, $event)"
              @delPic="onDelImg(item, $event)"
            >
              <div class="uploadbox">
                <i class="iconfont icon-shangchuan1"></i>
                <p class="fengmian">请上传封面</p>
                <p class="tips">注意图片尺寸为：3:2</p>
              </div>
            </upload-img>

            <!-- 地点选择 -->
            <template v-if="item.type === 'map'">
              <div
                class="address"
                v-if="edit || editMode"
                :class="{ address_nodata: !item.zuobiao.label }"
                @click="item.showMap = true"
              >
                {{ item.zuobiao.label || item.placeholder }}
                <i class="iconfont icon-dingweiweizhi"></i>
              </div>
              <p v-else class="form-value">{{ item.zuobiao.label }}</p>

              <map-modal
                v-if="item.showMap"
                :zuobiao="item.zuobiao"
                @confirm="getAddress(item, $event)"
                @cancel="item.showMap = false"
              ></map-modal>
            </template>

            <!-- 时间段 -->
            <template v-if="item.type === 'time-block'">
              <div
                class="time-block-item"
                v-for="(time, index) in item.list"
                :key="time.id || index"
                v-show="!time.id || time.id > 0"
              >
                <!-- prettier-ignore -->
                <div
                  class="time-block_time"
                >{{time.beginWeek | timeBlockDate }} 至 {{time.endWeek | timeBlockDate }} {{time.beginTime | timeBlockTime}}-{{time.endTime | timeBlockTime}}</div>
                <div
                  v-if="edit || editMode"
                  class="iconfont icon-bianji edit-icon"
                  @click="editBlockTime(item, time)"
                ></div>
                <div
                  v-if="edit || editMode"
                  class="iconfont icon-quxiao1 del-icon"
                  @click="delBlockTime(item, index)"
                ></div>
              </div>

              <Button
                v-if="edit || editMode"
                class="time-block-btn"
                type="primary"
                ghost
                @click.native="addTimeBlock(item)"
                >+ 添加</Button
              >
            </template>
          </FormItem>
        </Form>
      </Card>
    </section>

    <!-- modal -->
    <form-modal
      ref="briefModal"
      :modal="modal"
      :formOption="formOption"
      @radio-on-change="onRadioChange"
      @input-on-search="onInputSearch"
      @search-picker-onreachbottom="onReachBottom"
      @on-ok="onModalConfirm"
    ></form-modal>

    <!-- prettier-ignore -->
    <time-modal
      :show-model="formItemPoint && formItemPoint.showModal"
      :time-item="formItemPoint && formItemPoint._listPoint && formatTimeBlock(formItemPoint._listPoint)"
      @closeModal="onTimeModalClose"
      @handleTime="onTimeModalConfirm"
    ></time-modal>
  </div>
</template>

<script>
import util from "@/utils/util";

import formModal from "@/components/form-modal";
import uploadImg from "@/components/uploadImg";
import mapModal from "@/components/mapModal";
import selectPerson from "./components/select-person";
import timeModal from "../../Shequ/appointComponents/timeModal";

// 页面表单配置
const PAGE_CONFIG = {
  "26": {
    setFormLeft({
      selectPerson = {
        disabled: false,
        src: "",
        userName: "",
        value: {}
      },
      userName = {
        value: ""
      },
      userPhoneNO = {
        value: ""
      }
    } = {}) {
      return [
        {
          label: "需求方",
          name: "provider",
          type: "selectPerson",
          value: selectPerson.value,

          disabled: selectPerson.disabled,
          src: selectPerson.src,
          userName: selectPerson.userName
        },
        // 没有type 渲染空 FormItem
        {
          label: "联系人",
          class: "form-item_divider"
        },
        {
          label: "姓名",
          name: "userName",
          type: "input",
          value: userName.value,
          require: true
        },
        {
          label: "电话",
          name: "userPhoneNO",
          type: "input",
          value: userPhoneNO.value,
          require: true
        }
      ];
    },
    setFormRight({
      uploadImg = {
        value: "",
        list: []
      },
      phoneNO = {
        value: ""
      },
      address = {
        value: {
          address: "",
          coordinate: ""
        },
        zuobiao: {
          value: "",
          label: ""
        }
      },
      remark = {
        value: ""
      }
    } = {}) {
      return [
        {
          type: "uploadImg",
          label: "需求图片",
          fixedNumber: [3, 2],
          imgNumber: 1,
          list: uploadImg.list,
          name: "resourcePicUrl",
          value: uploadImg.value,
          require: true
        },
        {
          type: "map",
          label: "地址",
          placeholder: "请选择",
          showMap: false,
          zuobiao: address.zuobiao,
          name: "address",
          value: address.value,
          require: true
        },
        {
          type: "input-note",
          label: "社区电话",
          name: "phoneNO",
          placeholder: "请输入",
          note: "*用于居民或企业可提供对接资源或服务时联系",
          value: phoneNO.value,
          require: true
        },
        {
          type: "input",
          label: "需求描述",
          inputType: "textarea",
          autosize: { minRows: 4 },
          maxlength: 1024,
          showWordLimit: true,

          name: "remark",
          value: remark.value,
          require: true
        }
      ];
    }
  },
  "27": {
    setFormLeft({
      selectPerson = {
        disabled: false,
        src: "",
        userName: "",
        value: {}
      },
      userName = {
        value: ""
      },
      userPhoneNO = {
        value: ""
      }
    } = {}) {
      return [
        {
          label: "提供方",
          name: "provider",
          type: "selectPerson",
          value: selectPerson.value,

          disabled: selectPerson.disabled,
          src: selectPerson.src,
          userName: selectPerson.userName
        },
        // 没有type 渲染空 FormItem
        {
          label: "负责人",
          class: "form-item_divider"
        },
        {
          label: "姓名",
          name: "userName",
          type: "input",
          value: userName.value,
          require: true
        },
        {
          label: "电话",
          name: "userPhoneNO",
          type: "input",
          value: userPhoneNO.value,
          require: true
        }
      ];
    },
    setFormRight({
      uploadImg = {
        value: "",
        list: []
      },
      title = {
        value: ""
      },
      phoneNO = {
        value: ""
      },
      quantity = {
        value: ""
      },
      address = {
        value: {
          address: "",
          coordinate: ""
        },
        zuobiao: {
          value: "",
          label: ""
        }
      },
      timeList = {
        list: []
      },
      remark = {
        value: ""
      },
      instructions = {
        value: ""
      }
    } = {}) {
      return [
        {
          type: "uploadImg",
          label: "提供资源",
          fixedNumber: [3, 2],
          imgNumber: 1,
          list: uploadImg.list,
          name: "resourcePicUrl",
          value: uploadImg.value,
          require: true
        },
        {
          type: "input",
          label: "名称",
          placeholder: "请输入",
          showWordLimit: true,
          maxlength: 64,
          name: "title",
          value: title.value,
          require: true
        },
        {
          type: "map",
          label: "地址",
          placeholder: "请选择",
          showMap: false,
          zuobiao: address.zuobiao,
          name: "address",
          value: address.value,
          require: true
        },
        {
          type: "input-note",
          label: "社区电话",
          name: "phoneNO",
          placeholder: "请输入",
          note: "*用户居民使用此资源时联系",
          value: phoneNO.value,
          require: true
        },
        // list-item 字段 beginWeekValue endWeekValue beginTime endTime
        {
          type: "time-block",
          label: "开放时间",
          showModal: true,
          _listPoint: null, // list-item 指针
          list: timeList.list,

          name: "timeList",
          value: timeList.list,
          require: true
        },
        {
          type: "input",
          label: "数量",
          placeholder: "请输入数量",
          name: "quantity",
          inputType: "number",
          value: quantity.value,
          require: true
        },
        {
          type: "input",
          label: "资源描述",
          inputType: "textarea",
          autosize: { minRows: 4 },
          maxlength: 1024,
          showWordLimit: true,

          name: "remark",
          value: remark.value,
          require: true
        },
        {
          type: "input",
          label: "使用方法",
          inputType: "textarea",
          autosize: { minRows: 4 },
          maxlength: 1024,
          showWordLimit: true,

          name: "instructions",
          value: instructions.value,
          require: true
        }
      ];
    }
  },
  "28": {
    setFormLeft({
      selectPerson = {
        disabled: false,
        src: "",
        userName: "",
        value: {}
      },
      userName = {
        value: ""
      },
      userPhoneNO = {
        value: ""
      }
    } = {}) {
      return [
        {
          label: "提供方",
          name: "provider",
          type: "selectPerson",
          value: selectPerson.value,

          disabled: selectPerson.disabled,
          src: selectPerson.src,
          userName: selectPerson.userName
        },
        // 没有type 渲染空 FormItem
        {
          label: "负责人",
          class: "form-item_divider"
        },
        {
          label: "姓名",
          name: "userName",
          type: "input",
          value: userName.value,
          require: true
        },
        {
          label: "电话",
          name: "userPhoneNO",
          type: "input",
          value: userPhoneNO.value,
          require: true
        }
      ];
    },
    getLeftRules() {
      return {
        userName: [
          { required: true, message: "姓名为必填项", trigger: "blur" }
        ],
        userPhoneNO: [
          { required: true, message: "电话为必填项", trigger: "blur" }
        ]
      };
    },
    setFormRight({
      uploadImg = {
        value: "",
        list: []
      },
      title = {
        value: ""
      },
      phoneNO = {
        value: ""
      },
      quantity = {
        value: ""
      },
      resourceStatus = {
        value: 1,
        list: [
        {
          value: 0,
          label: "已完成"
        },
        {
          value: 1,
          label: "进行中"
        }
      ],
      },
      address = {
        value: {
          address: "",
          coordinate: ""
        },
        zuobiao: {
          value: "",
          label: ""
        }
      },
      timeList = {
        list: []
      },
      remark = {
        value: ""
      }
    } = {}) {
      return [
        {
          type: "uploadImg",
          label: "服务项目",
          fixedNumber: [3, 2],
          imgNumber: 1,
          list: uploadImg.list,
          name: "resourcePicUrl",
          value: uploadImg.value,
          require: true
        },
        {
          type: "input",
          label: "名称",
          placeholder: "请输入",
          showWordLimit: true,
          maxlength: 64,
          name: "title",
          value: title.value,
          require: true
        },
        {
          type: "map",
          label: "地址",
          placeholder: "请选择",
          showMap: false,
          zuobiao: address.zuobiao,
          name: "address",
          value: address.value,
          require: true
        },
        {
          type: "input-note",
          label: "社区电话",
          name: "phoneNO",
          placeholder: "请输入",
          note: "*用户居民使用此服务时联系",
          value: phoneNO.value,
          require: true
        },
        // list-item 字段 beginWeekValue endWeekValue beginTime endTime
        {
          type: "time-block",
          label: "服务时间",
          showModal: true,
          _listPoint: null, // list-item 指针
          list: timeList.list,

          name: "timeList",
          value: timeList.list,
          require: true
        },
        {
          type: "select",
          label: "资源状态",
          list: resourceStatus.list,
          name: "resourceStatus",
          value: resourceStatus.value,
        },
        {
          type: "input",
          label: "数量",
          placeholder: "请输入数量",
          name: "quantity",
          inputType: "number",
          value: quantity.value,
          require: true
        },
        {
          type: "input",
          label: "服务描述",
          inputType: "textarea",
          autosize: { minRows: 4 },
          maxlength: 1024,
          showWordLimit: true,

          name: "remark",
          value: remark.value,
          require: true
        }
      ];
    }
  }
};
// 搜索人员的表单配置
let selectPersonFormOption = {
  searchLabel: "搜索",
  setOption: function({
    radio = {
      value: "企业"
    },
    search = {
      value: ""
    },
    person = {
      list: []
    }
  } = {}) {
    return [
      {
        type: "radio",
        title: "类型",
        name: "type",
        value: radio.value,
        list: [
          {
            label: "企业",
            trueValue: "company"
          },
          {
            label: "个人",
            trueValue: "resident"
          }
        ]
      },
      {
        type: "input",
        name: "search",
        title: this.searchLabel,
        value: search.value,
        search: true,
        enterButton: "搜索"
      },
      {
        type: "search-picker",
        name: "person",
        list: person.list
      }
    ];
  }
};

// 判断是不是没有值
let valueCheck = function(obj) {
  if (util.type(obj) === "object") {
    for (const attr of Object.values(obj)) {
      return valueCheck(attr);
    }
  }
  if (util.type(obj) === "array") return obj.length === 0;
  return obj === "";
};
// 简单的表单校验
let formCheck = function(list) {
  for (const item of list) {
    if (!item.name) continue;
    if (item.require && valueCheck(item.value)) return `${item.label}是必填项`;
  }
  return false;
};

export default {
  name: "share-publish",
  components: { selectPerson, formModal, uploadImg, mapModal, timeModal },
  props: {},
  data() {
    return {
      editMode: false, // 页面的编辑模式
      formOption: [],
      statusList: [
        {
          value: 0,
          label: "已完成"
        },
        {
          value: 1,
          label: "进行中"
        }
      ],
      modal: {},
      searchPerson: {
        label: "企业",
        trueValue: "company"
      }, // 搜索人员企业的参数 默认值
      searchPersonPageNum: 1, // 人员搜素的分页
      searchPersonPageSize: 12, // 人员搜索分页量
      searchPersonNoMore: false, // 搜索人员数据是否加载完成
      searchPersonListCache: [], // 搜索人员列表缓存

      pagePoint: null, // 页面配置指针
      formItemPoint: null, // 表单项指针
      formLeft: [], // 左侧表单
      formRight: [] // 右侧
    };
  },
  filters: {
    // 时间格式化 去秒
    timeBlockTime(val) {
      return val.slice(0, -3);
    },
    // 日期格式化
    timeBlockDate(val) {
      return util.handelWeek(val);
    }
  },
  watch: {},
  computed: {
    // 组件接口
    title() {
      return this.$route.query.title;
    },
    resourceType() {
      return this.$route.query.resourceType;
    },
    shareId() {
      return this.$route.query.id;
    },
    detail() {
      return this.$route.query.detail;
    },
    edit() {
      return this.$route.query.edit;
    }

    // 左侧表单数据模型
  },
  methods: {
    // 进入编辑状态
    toEdit() {
      this.editMode = true;
    },
    // 表单提交
    submit() {
      // 左侧表单校验
      let checkRes = formCheck(this.formLeft);
      if (checkRes) return this.$Message.warning(checkRes);
      // 右侧表单校验
      checkRes = formCheck(this.formRight);
      if (checkRes) return this.$Message.warning(checkRes);

      let mergefn = (pre, cur) => {
        // 没有name 结束本次合并
        if (!cur.name) return pre;
        // 参数为对象类型直接合并
        if (this.$util.type(cur.value) === "object")
          return Object.assign(pre, cur.value);
        // 默认赋值
        pre[cur.name] = cur.value;
        return pre;
      };
      // 合并参数 -> value 对象类型直接展开不再取name
      let leftData = this.formLeft.reduce(mergefn, {});
      let rightData = this.formRight.reduce(mergefn, {});
      // 接口参数
      let data = {
        id: this.shareId,
        resourceType: this.resourceType,
        ...leftData,
        ...rightData
      };
      this.$showLoading();
      console.log(data)
      this.$post(this.urlobj.share_resource, data)
        .then(res => {
          this.$Message.success("发布成功");
          setTimeout(this.goBack, 1500);
        })
        .finally(this.$hideLoading);
    },
    /* 选择人员或企业 弹窗*/
    onChoosePerson(item) {
      selectPersonFormOption.searchLabel = item.label;
      this.formOption = selectPersonFormOption.setOption();

      this.modal = {
        value: true,
        title: item.label
      };
    },
    onRadioChange(e) {
      this.searchPerson = e;
      // 默认执行一次搜索
      this.onInputSearch('')
    },
    // 搜索 企业或人员
    onInputSearch(searchVal = null) {
      // 有搜索行为
      if (searchVal !== null) {
        this.searchPersonPageNum = 1;
        this.searchPersonListCache.length = 0;
        this.searchPersonNoMore = false;
      }
      let url = this.urlobj.share_provider(this.searchPerson.trueValue);
      let data = {
        pageNum: this.searchPersonPageNum,
        pageSize: this.searchPersonPageSize,
        searchValue: searchVal
      };
      this.$refs.briefModal.showLoading();
      this.$get(url, data)
        .then(res => {
          // 是否加载完成数据
          if (res.rows.length < this.searchPersonPageSize)
            this.searchPersonNoMore = true;

          this.searchPersonListCache.push(
            ...res.rows.map(item => {
              return {
                key: item.unionId || item.companyId,
                unionId: item.unionId,
                companyId: item.companyId,
                imgUrl: item.headPicUrl,
                realName: item.realName,
                nickName: item.userName,
                phoneNO: item.phoneNO
              };
            })
          );

          // 更新表单视图
          this.formOption = selectPersonFormOption.setOption({
            radio: {
              value: this.searchPerson.label
            },
            search: {
              value: searchVal
            },
            person: {
              list: this.searchPersonListCache
            }
          });
        })
        .finally(this.$refs.briefModal.hideLoading);
    },
    onReachBottom() {
      if (this.searchPersonNoMore) return;

      ++this.searchPersonPageNum;
      this.onInputSearch();
    },
    // 选择人员的表单确定
    onModalConfirm(form) {
      let [cur] = form.get("person").list.filter(item => item.selected);
      if (!cur) return; // 没有选择任何 直接返回

      // 信息回填
      this.formLeft = this.pagePoint.setFormLeft({
        selectPerson: {
          disabled: false,
          src: cur.imgUrl || require("@/assets/images/default.png"),
          userName: cur.nickName,
          value: {
            companyId: cur.companyId,
            unionId: cur.unionId,
            headPicUrl: cur.imgUrl
          }
        },
        userName: {
          value: cur.realName || cur.nickName
        },
        userPhoneNO: {
          value: cur.phoneNO
        }
      });
    },
    // 完成图片上传
    onUploadImg(item, event) {
      item.list.splice(0, 1, event);
      // 更新value
      item.value = event.path;
    },
    // 删除图片
    onDelImg(item, event) {
      item.list.pop(); // 只有一个图片
    },
    getAddress(item, val) {
      item.zuobiao = val;
      item.showMap = false;

      // 更新value
      let [x, y] = val.value.split(",");
      item.value = {
        address: val.label,
        coordinate: JSON.stringify({ x, y })
      };
    },
    editBlockTime(item, time) {
      // form 指向当前表单对象
      this.formItemPoint = item;
      // list 指向操作的时间对象
      this.formItemPoint._listPoint = time;
      // 显示弹窗
      this.formItemPoint.showModal = true;
    },
    // 格式化组件传入值
    formatTimeBlock(val) {
      return {
        beginWeekValue: val.beginWeek,
        endWeekValue: val.endWeek,
        beginTime: val.beginTime.slice(0, -3),
        endTime: val.endTime.slice(0, -3)
      };
    },
    delBlockTime(item, index) {
      let cur = item.list[index];

      if (cur.id) {
        cur.id = -cur.id;
      } else {
        item.list.splice(index, 1);
      }
    },
    // 显示timemodal
    addTimeBlock(item) {
      // 重设 指针
      this.formItemPoint = item;
      this.formItemPoint._listPoint = null;

      this.formItemPoint.showModal = true;
    },
    onTimeModalClose() {
      this.formItemPoint.showModal = false;
    },
    onTimeModalConfirm(e) {
      // 关闭弹窗
      this.formItemPoint.showModal = false;
      // 格式化新类目
      let _tmp = {
        beginWeek: e.beginWeekValue,
        endWeek: e.endWeekValue,
        beginTime: e.beginTime + ":00",
        endTime: e.endTime + ":00"
      };
      let cur = this.formItemPoint._listPoint;

      // 如果原对象有id 执行隐藏原对象 新对象代替原位置
      if (cur && cur.id) {
        cur.id = -cur.id;
        return this.formItemPoint.list.forEach((item, index) => {
          if (item === cur) this.formItemPoint.list.splice(index, 0, _tmp);
        });
      }

      // 原对象没有id 执行替换
      if (cur && !cur.id) {
        return this.formItemPoint.list.forEach((item, index) => {
          if (item === cur) this.formItemPoint.list.splice(index, 1, _tmp);
        });
      }

      // 插入新增对象
      this.formItemPoint.list.push(_tmp);
    },
    getDetailForm() {
      let url = this.urlobj.share_getDetail(this.shareId);
      this.$showLoading();
      this.$get(url)
        .then(res => {
          let detail = res.rows[0];
          // 更新左侧表单
          this.formLeft = this.pagePoint.setFormLeft({
            selectPerson: {
              disabled: !this.edit, // 如果是编辑 则false
              src: detail.headPicUrl,
              userName: detail.userName,
              value: {
                companyId: detail.companyId,
                unionId: detail.unionId,
                headPicUrl: detail.headPicUrl
              }
            },
            userName: {
              value: detail.userName
            },
            userPhoneNO: {
              value: detail.userPhoneNO
            }
          });

          // 更新右侧表单
          let { x, y } = JSON.parse(detail.coordinate);
          this.formRight = this.pagePoint.setFormRight({
            uploadImg: {
              value: detail.resourcePicUrl,
              list: [{ path: detail.resourcePicUrl }]
            },
            title: {
              value: detail.title
            },
            phoneNO: {
              value: detail.phoneNO
            },
            address: {
              value: {
                address: detail.address,
                coordinate: detail.coordinate
              },
              zuobiao: {
                label: detail.address,
                value: `${x},${y}`
              }
            },
            timeList: {
              list: detail.timeList.map(item => ({
                id: item.id,
                beginTime: item.beginTime,
                beginWeek: item.beginWeek,
                endTime: item.endTime,
                endWeek: item.endWeek
              }))
            },
            quantity: {
              value: detail.quantity
            },
            instructions: {
              value: detail.instructions
            },
            resourceStatus: {
              value: detail.resourceStatus,
              list: [
                {
                  value: 0,
                  label: "已完成"
                },
                {
                  value: 1,
                  label: "进行中"
                }
              ],
            },  
            remark: {
              value: detail.remark
            }
          });
        })
        .finally(this.$hideLoading);
    },
    // 初始化表单
    initForm() {
      this.formLeft = this.pagePoint.setFormLeft();
      // this.formLeftRules = this.pagePoint.getLeftRules();
      this.formRight = this.pagePoint.setFormRight();
    },
    goBack() {
      // 如果是编辑模式 点击退出编辑模式
      if (this.editMode) return (this.editMode = false);

      // 不是编辑模式返回上一页
      this.$router.back();
    }
  },
  created() {
    // 1. 初始化页面对象
    this.pagePoint = PAGE_CONFIG[this.resourceType];
    // 2. 如果有页面id 获取带有详情的表单
    if (this.shareId) return this.getDetailForm();
    // 3. 默认初始化空值表单
    this.initForm();
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
@baseGap: 0.2rem;

.pub-wrap {
  height: 100%;
  .flex(@flexDirection:column);
  padding: @baseGap;
}
.header {
  flex-shrink: 0;
  .flex(center, space-between);
  margin-bottom: @baseGap;
}
.header-back {
  .setArrow(left, 0.14rem, #999, 2px);
  cursor: pointer;
}
.header-title {
  font-size: 0.25rem;
  color: #666;
}

.pub-content {
  flex: 1;
  .flex();
}
.content-left {
  flex: 1;
  margin-right: @baseGap;
}
.content-right {
  flex: 2;
}
.form-label {
  font-size: 0.16rem;
  color: #4b4b4b;
}
.form-value {
  color: #999;
  // 与iview一致 垂直居中
  line-height: 0.16rem;
  padding: 10px 0;
}
.form-item_divider {
  margin-bottom: @baseGap / 2;
}

/* 上传图片 */
.uploadbox {
  width: 238px;
  height: 148px;
  border: 1px dashed #ddd;
  text-align: center;
  margin-top: 12px;
  .icon-shangchuan1 {
    display: block;
    font-size: 37px;
    color: #e3e3e3;
    margin-top: 32px;
  }
  .fengmian {
    font-size: 14px;
    color: #666;
    margin-top: 10px;
  }
  .tips {
    font-size: 14px;
    color: #999;
  }
}

/*选择地点的样式*/
.address {
  width: 100%;
  height: 32px;
  line-height: 24px;
  padding: 4px 7px;
  font-size: 12px;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  color: #515a6e;
  background-color: #fff;
  background-image: none;
  position: relative;
  cursor: text;

  .icon-dingweiweizhi {
    float: right;
  }
}
.address_nodata {
  color: #bbb;
}
.address:hover {
  border: 1px solid #ff7b44;
}
.address:active {
  border: 1px solid #ff7b44;
}

.input-note {
  color: #999;
  font-size: 12px;
}
// 时间段选择器
.time-block-item {
  .flex(center);
  margin-bottom: 16px;

  .edit-icon {
    font-size: 18px;
    color: #6b82bf;
    margin-left: 16px;
    cursor: pointer;
  }
  .del-icon {
    font-size: 18px;
    color: #f43f3e;
    margin-left: 16px;
    cursor: pointer;
  }
}
.time-block_time {
  color: #999;
  font-size: 14px;
}
.time-block-btn {
  line-height: 1;
}
</style>
